import styles from "../../../styles/Participant-Employment.module.css"
import { InputNumber } from "primereact/inputnumber"
const NumberField = ({ label, value, setValue, valueName, minValue, maxValue, size }) => {
  return (
    <div className={styles.field} style={{ width: "100%" }}>
      <label className={styles.label}>{label}</label>
      <InputNumber
        className={styles.fix_input_number}
        value={value}
        min={minValue ? minValue : 0}
        onChange={(e) => {
          valueName ? setValue(valueName, e.value) : setValue(e.value)
        }}
        style={{ width: `${size ? size : "100"}%` }}
        showButtons
        max={maxValue}
        useGrouping={false}
      />
    </div>
  )
}
export default NumberField
